import { Component, OnInit,ViewEncapsulation, Input, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ChatInputComponent implements OnInit {
  
  // @Input() apiurl: string;
  @Input() showTextArea: Boolean;
  @Input() avaImageQuery:string;
  @Input() avaImageUrl:string;
  // @Input() postMessage: Function;
  @Output() postMessage: EventEmitter<any> = new EventEmitter();
  @Input() content:any;
  @ViewChild("msgInput",{static:false}) msgInput;
  constructor() { }

  ngOnInit() {
  }

  confirmPost(inputValue:string, payload:any) {
    this.postMessage.emit({
      inputValue,
      payload
    })
    this.msgInput.nativeElement.value =""
  }

  

}
